import React, { createContext } from "react";

export const NotiContext = createContext();
export const NotiProvider = ({ children, noti, setNoti }) => {
    return (
        <NotiContext.Provider value={{ noti, setNoti }}>
            {children}
        </NotiContext.Provider>
    )
};